import { useEffect, useRef, useCallback } from 'react';
import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_API_URL?.replace('/api', '') || 'http://localhost:5001';

export function useSocket(userId) {
  const socketRef = useRef(null);

  useEffect(() => {
    if (!userId) return;

    const socket = io(SOCKET_URL, {
      transports: ['websocket', 'polling'],
      withCredentials: true,
    });

    socket.on('connect', () => {
      console.log('Socket connected');
      socket.emit('join', userId);
    });

    socket.on('disconnect', () => {
      console.log('Socket disconnected');
    });

    socketRef.current = socket;

    return () => {
      socket.disconnect();
      socketRef.current = null;
    };
  }, [userId]);

  const joinProject = useCallback((projectId) => {
    if (socketRef.current) socketRef.current.emit('join_project', projectId);
  }, []);

  const onNotification = useCallback((callback) => {
    if (socketRef.current) {
      socketRef.current.on('notification', callback);
      return () => socketRef.current?.off('notification', callback);
    }
  }, []);

  const onGroupMessage = useCallback((callback) => {
    if (socketRef.current) {
      socketRef.current.on('group_message', callback);
      return () => socketRef.current?.off('group_message', callback);
    }
  }, []);

  const onNewMessage = useCallback((callback) => {
    if (socketRef.current) {
      socketRef.current.on('new_message', callback);
      return () => socketRef.current?.off('new_message', callback);
    }
  }, []);

  return { socket: socketRef.current, joinProject, onNotification, onGroupMessage, onNewMessage };
}
